import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_PARAMETER} from '../../constants';

export default {
  id: 'INFO_RAPP_HEBDO',
  title: 'Cosa sono i resoconti settimanali?',
  description: '',
  categories: [CONTENT_CATEGORY_PARAMETER],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Se attivate i resoconti Settimanali riceverete ogni settimana via e-mail l\'elenco dei vostri fornitori con lo stato del loro File. È inoltre possibile attivarli per i fornitori relativi alle operazioni.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Per modificare i resoconti settimanali, clicca sull\' ometto in basso a sinistra'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_INFO_RAPP_HEBDO/IT_INFO_RAPP_HEBDO_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Visita «Informazioni personali»'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_INFO_RAPP_HEBDO/IT_INFO_RAPP_HEBDO_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Abilita o disabilita i resoconti, quindi convalida!'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_INFO_RAPP_HEBDO/IT_INFO_RAPP_HEBDO_3.png`
  }]
};
